export default "__VITE_ASSET__Rak95HrK__"